import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Table, Spin } from 'antd'
import { getStockroomsAction, stockroomSelector } from '../../../store/stockroom'

const columns = [
  {
    title: '№',
    dataIndex: 'id',
    key: 'id',
    align: 'right',
    width: 60,
  },
  {
    title: 'Название',
    dataIndex: ['attributes', 'name'],
    key: 'name',
  },
  {
    title: 'Проект',
    dataIndex: ['attributes', 'project', 'data', 'attributes', 'name'],
    key: 'project',
    render: (value) => (value != null ? value : '-'),
  },
]

const StockroomsTable = () => {
  const dispatch = useDispatch()

  const { isFetching, pagination, stockrooms } = useSelector(stockroomSelector)

  const [page, setPage] = useState(1)

  const tablePagination = useMemo(
    () => ({
      current: page,
      pageSize: 10,
      total: pagination.total,
      onChange: setPage,
      showSizeChanger: false,
    }),
    [pagination, page]
  )

  useEffect(() => {
    dispatch(getStockroomsAction({ pagination: { page, pageSize: 10 } }))
  }, [dispatch, page])

  return (
    <Spin spinning={isFetching}>
      <div>
        <Table
          style={{ paddingTop: 20 }}
          pagination={tablePagination}
          columns={columns}
          dataSource={stockrooms}
          size="small"
          bordered
        />
      </div>
    </Spin>
  )
}

export default StockroomsTable
